import {
  INFO_BOX_SINGLE,
  PRICE_BOX_SINGLE,
  WEIGHT_BOX_SINGLE,
  SIZE_BOX_SINGLE,
  WIDTH_BOX_SINGLE,
  HEIGHT_BOX_SINGLE,
  LENGTH_BOX_SINGLE,
  NEED_BOX_SINGLE,
  FACTOR_BOX_SINGLE,
  NOTIFICATION_BOX_SINGLE,
  TRADEMARK_BOX_SINGLE,
  BREAKABLE_BOX_SINGLE,
  LIQUID_BOX_SINGLE,
  PAYMENT_TYPE_BOX_SINGLE,
  AGENT_SERVICES_BOX_SINGLE,
  RESET_STATE_BOX_SINGLE
} from "../../Types";


const initialState = {
  info: '',
  price: '',
  weight: '',
  size: '',
  width: '',
  height: '',
  length: '',
  need: true,
  factor: false,
  notification: false,
  trademark: false,
  breakable: false,
  liquid: false,
  payment_type: '',
  agent_services: '',
}

export const infoBoxReducer = (state = initialState, action) => {
  switch (action.type) {
    case INFO_BOX_SINGLE: {
      return {
        ...state,
        info: action.payload,
      };
    }
    case PRICE_BOX_SINGLE: {
      return {
        ...state,
        price: action.payload,
      };
    }
    case WEIGHT_BOX_SINGLE: {
      return {
        ...state,
        weight: action.payload,
      };
    }
    case SIZE_BOX_SINGLE: {
      return {
        ...state,
        size: action.payload,
      };
    }
    case WIDTH_BOX_SINGLE: {
      return {
        ...state,
        width: action.payload,
      };
    }
    case HEIGHT_BOX_SINGLE: {
      return {
        ...state,
        height: action.payload,
      };
    }
    case LENGTH_BOX_SINGLE: {
      return {
        ...state,
        length: action.payload,
      };
    }
    case NEED_BOX_SINGLE: {
      return {
        ...state,
        need: action.payload,
      };
    }
    case FACTOR_BOX_SINGLE: {
      return {
        ...state,
        factor: action.payload,
      };
    }
    case NOTIFICATION_BOX_SINGLE: {
      return {
        ...state,
        notification: action.payload,
      };
    }
    case TRADEMARK_BOX_SINGLE: {
      return {
        ...state,
        trademark: action.payload,
      };
    }
    case BREAKABLE_BOX_SINGLE: {
      return {
        ...state,
        breakable: action.payload,
      };
    }
    case LIQUID_BOX_SINGLE: {
      return {
        ...state,
        liquid: action.payload,
      };
    }
    case PAYMENT_TYPE_BOX_SINGLE: {
      return {
        ...state,
        payment_type: action.payload,
      };
    }
    case AGENT_SERVICES_BOX_SINGLE: {
      return {
        ...state,
        agent_services: action.payload,
      };
    }
    case RESET_STATE_BOX_SINGLE:
      return initialState;
    default:
      return state;
  }
};
